export var FIVE_SECONDS = 5 * 1000;
export var THIRTY_SECONDS = 30 * 1000;
export var FIFTEEN_MINUTES = 15 * 60 * 1000;
export var DEFAULT_INTERVAL = FIVE_SECONDS;
